import { DestroyRef, Directive, ElementRef, effect, inject, input } from '@angular/core';

import { ReducedMotionFacade, REDUCED_MOTION_MAX_LOOPS } from '../reduced-motion-facade';

@Directive({
  selector: 'video[spacesLoopLimit]',
})
export class LoopLimitDirective {
  private readonly reducedMotionFacade = inject(ReducedMotionFacade);
  private readonly hostRef = inject(ElementRef<HTMLVideoElement>);
  private readonly destroyRef = inject(DestroyRef);

  public readonly spacesLoopLimit = input(REDUCED_MOTION_MAX_LOOPS, {
    transform: (value: number | string) =>
      typeof value === 'number' ? value : Number(value) || REDUCED_MOTION_MAX_LOOPS,
  });

  private playCount = 0;
  private endedListener: (() => void) | null = null;

  public constructor() {
    effect(() => {
      const reduced = this.reducedMotionFacade.isActive();
      const video = this.hostRef.nativeElement;

      this.detachEndedListener();
      this.playCount = 0;

      if (!reduced) {
        video.loop = true;
        return;
      }

      video.loop = false;
      const max = this.spacesLoopLimit();

      const onEnded = () => {
        this.playCount++;
        if (this.playCount < max) {
          video.play().catch(() => {
            // Autoplay can be blocked when not user-initiated. Stop counting.
          });
        }
      };

      video.addEventListener('ended', onEnded);
      this.endedListener = () => video.removeEventListener('ended', onEnded);
    });

    this.destroyRef.onDestroy(() => this.detachEndedListener());
  }

  private detachEndedListener() {
    if (this.endedListener) {
      this.endedListener();
      this.endedListener = null;
    }
  }
}
